import MapperCarrito from "@/assets/js/class/MapperCarrito.js";
const state = {
  open: false,
  hoteles: [],
  cupos: [],
  tickets: [],
  traslados: [],
  gastoReserva: 0,
  validHabCupo: [],
  validarSegunBusqueda: true,
  boton: { visibled: false, classObject: { "v-btn--disabled": true } }
};
const getters = {
  cartServicios: (state, getters, rootState) => {
    let incluyeGastoRsv = false;
    var cupos = { tarifa: 0, iva: 0, gastoAdm: 0, tasas: 0 };
    var hoteles = { tarifa: 0, iva: 0, gastoAdm: 0, tasas: 0 };
    var traslados = { tarifa: 0, iva: 0, gastoAdm: 0, tasas: 0 };
    var pases = { tarifa: 0, iva: 0, gastoAdm: 0, tasas: 0 };
    var moneda = null;
    let ipais = 0;
    let ipais2 = 0;
    let ipais3 = 0;
    state.traslados.forEach(t => {
      incluyeGastoRsv = true;
      t.traslados.forEach(tr => {
        traslados.tarifa =
          traslados.tarifa + parseFloat(tr.tarifas.totales.venta);
        traslados.iva = traslados.iva + parseFloat(tr.tarifas.totales.iva);
        traslados.gastoAdm =
          traslados.gastoAdm +
          parseFloat(tr.tarifas.totales.gasto_administrativo);
        ipais = ipais + parseFloat(tr.tarifas.totales.afip);
        ipais2 = ipais2 + parseFloat(tr.tarifas.totales.afip2);
        ipais3 = ipais3 + (parseFloat(tr.tarifas.totales.costo) * 5) / 100; // percepcion 5272
        moneda = tr.tarifas.totales.moneda;
      });
    });
    state.tickets.forEach(t => {
      pases.tarifa = pases.tarifa + parseFloat(t.tarifas.totales.venta);
      pases.iva = pases.iva + parseFloat(t.tarifas.totales.iva);
      pases.gastoAdm =
        pases.gastoAdm + parseFloat(t.tarifas.totales.gasto_administrativo);
      ipais = ipais + parseFloat(t.tarifas.totales.afip);
      ipais2 = ipais2 + parseFloat(t.tarifas.totales.afip2);
      ipais3 = ipais3 + (parseFloat(t.tarifas.totales.costo) * 5) / 100;
      moneda = t.tarifas.totales.moneda;
    });
    state.cupos.forEach(function(c) {
      incluyeGastoRsv = true;
      cupos.tarifa = cupos.tarifa + parseFloat(c.totales.venta);
      cupos.iva = cupos.iva + parseFloat(c.totales.iva);
      cupos.gastoAdm =
        cupos.gastoAdm + parseFloat(c.totales.gastoAdministrativo);
      cupos.tasas = cupos.tasas + parseFloat(c.totales.tasa);
      ipais = ipais + +parseFloat(c.totales.afip);
      ipais2 = ipais2 + parseFloat(c.afip2 || 0);
      ipais3 = ipais3 + (parseFloat(c.totales.costo || 0) * 5) / 100;
      moneda = c.totales.moneda;
    });

    state.hoteles.forEach(function(h) {
      incluyeGastoRsv = true;
      h.habitaciones.forEach(function(hb) {
        hoteles.tarifa =
          hoteles.tarifa + parseFloat(hb.habitacion.tarifas.tarifa.venta);
        hoteles.iva =
          hoteles.iva + parseFloat(hb.habitacion.tarifas.tarifa.iva);
        hoteles.gastoAdm =
          hoteles.gastoAdm +
          parseFloat(hb.habitacion.tarifas.tarifa.gasto_administrativo);
        ipais = ipais + +parseFloat(hb.habitacion.tarifas.tarifa.afip);
        ipais2 = ipais2 + +parseFloat(hb.habitacion.tarifas.tarifa.afip2);
        ipais3 = ipais3 + (hb.habitacion.tarifas.tarifa.costo * 5) / 100;
        moneda = hb.habitacion.tarifas.tarifa.moneda;
        hb.habitacion.tickets.forEach(t => {
          hoteles.tarifa = hoteles.tarifa + parseFloat(t.tarifas.totales.venta);
          hoteles.iva = hoteles.iva + parseFloat(t.tarifas.totales.iva);
          hoteles.gastoAdm =
            hoteles.gastoAdm +
            parseFloat(t.tarifas.totales.gasto_administrativo);
          ipais = ipais + parseFloat(t.tarifas.totales.afip);
          ipais2 = ipais2 + parseFloat(t.tarifas.totales.afip2);
          ipais3 = ipais3 + (parseFloat(t.tarifas.totales.costo) * 25) / 100;
        });
        hb.habitacion.comidas.forEach(c => {
          c.tarifas.tarifa.forEach(t => {
            if (t["@attributes"].tipo != "total") {
              return;
            }
            hoteles.iva = hoteles.iva + parseFloat(t.iva);
            hoteles.tarifa = hoteles.tarifa + parseFloat(t.venta);
            hoteles.gastoAdm =
              hoteles.gastoAdm + parseFloat(t.gasto_administrativo);
            ipais = ipais + parseFloat(t.afip);
            ipais2 = ipais2 + parseFloat(t.afip2);
            ipais3 = ipais3 + (parseFloat(t.costo) * 25) / 100;
          });
        });
      });
    });
    var gastoRsv = incluyeGastoRsv ? 35 : 0;
    var tarifa =
      cupos.tarifa + hoteles.tarifa + traslados.tarifa + pases.tarifa;
    var gastoAdm =
      cupos.gastoAdm + hoteles.gastoAdm + traslados.gastoAdm + pases.gastoAdm;
    var tasas = cupos.tasas + hoteles.tasas;
    var iva = cupos.iva + hoteles.iva + traslados.iva + +pases.iva;
    var total = tarifa + gastoAdm + tasas + iva + parseFloat(gastoRsv);
    var totales = {
      gastoRsv: gastoRsv.toFixed(2),
      tarifa: tarifa.toFixed(2),
      gastoAdm: gastoAdm.toFixed(2),
      tasas: tasas.toFixed(2),
      total: total.toFixed(2),
      iva: iva.toFixed(2),
      moneda: moneda,
      ipais: ipais.toFixed(2),
      ipais2: ipais2.toFixed(2),
      ipais3: ipais3.toFixed(2)
    };

    return {
      hoteles: state.hoteles,
      cupos: state.cupos,
      traslados: state.traslados,
      tickets: state.tickets,
      tarifas: totales
    };
  },
  getCantidadServicios: (state, getters, rootState) => {
    let contador = 0;
    state.hoteles.forEach(h => {
      h.habitaciones.forEach(h => {
        contador++;
        contador = contador + h.habitacion.tickets.length;
        contador = contador + h.habitacion.comidas.length;
      });
    });
    contador = contador + state.tickets.length;
    contador = contador + state.traslados.length;
    contador = contador + state.cupos.length;
    return contador;
  },
  getValidHab: (state, getters, rootState) => {
    return state.validHabCupo;
  },
  getValidarSegunBusqueda: (state, getters, rootState) => {
    return state.validarSegunBusqueda;
  },
  hayHotel: (state, getters, rootState) => {
    return state.hoteles.length > 0 ? true : false;
  },
  getBoton: (state, getters, rootState) => {
    return state.boton;
  },
  getOpen: state => {
    return state.open;
  }
};

const actions = {
  agregar({ commit, state, dispatch }, item) {
    commit("addtoCarrito", { item });
  },
  limpiar({ commit, state }, item) {
    commit("limpiarCarrito", { item });
  },
  setGastoReserva({ commit, state }, item) {
    commit("setGastoReserva", { item });
  },
  tomaHabitacionesCupo({ commit, state }, item) {
    commit("limpiarValidHab");
    item.habitaciones.forEach(function(h) {
      var mapper = new MapperCarrito();
      var valido = mapper.generarValidez(
        item.destino,
        h.adl.toString(),
        h.menores.edades
      );
      commit("agregarValidHab", valido);
    });
  },
  agregarHabitacion({ commit, state, dispatch }, item) {
    var mapper = new MapperCarrito();
    var agregar = mapper.esAgregado(
      state.validHabCupo,
      state.validarSegunBusqueda,
      item
    );
    if (agregar.agregar) {
      var data = { tipo: "h", data: agregar.hotel };
      dispatch("agregar", data);
    }
    if (state.validarSegunBusqueda) {
      const index = state.validHabCupo.findIndex(
        valid => !valid.tomado && valid.codigo == agregar.agregado
      );
      if (index != -1) {
        commit("checkValidHab", { index: index, valor: true });
      }
    }
    return agregar;
  },
  habitacion2Eliminar({ commit, state, dispatch }, eliminar) {
    // Busca el indice del hotel, en caso de no encontrarlo contesta falso al componente
    var indexHotel = state.hoteles.findIndex(
      hotel => hotel.unico_carrito == eliminar.unico
    );
    if (indexHotel == -1) {
      return false;
    }
    // Busca el indice de la habitacion, en caso de no encontrarlo contesta falso al componente
    var indexHabi = state.hoteles[indexHotel].habitaciones.findIndex(
      h =>
        h.habitacion.clase == eliminar.clase &&
        h.habitacion.codigo == eliminar.codigo &&
        h.habitacion.ocupacion == eliminar.ocupacion
    );
    if (indexHabi == -1) {
      return false;
    }
    var borrar = { indexhotel: indexHotel, indexhabi: indexHabi };
    // Si no se valida que las habitaciones seleccionadas directamente borra la habitacion y contesta al componente
    if (!state.validarSegunBusqueda) {
      commit("borrar", borrar);
      return true;
    }
    var mapper = new MapperCarrito();
    // Se crea el digo de validacion del carrito
    var codValid = mapper.generarCodigoCarrito(
      state.hoteles[indexHotel].destinoBuscador,
      state.hoteles[indexHotel].habitaciones[indexHabi].habitacion.tarifas
        .tarifa["@attributes"].adl,
      state.hoteles[indexHotel].habitaciones[indexHabi].habitacion.menores
        .edades.edad
    );
    // Se busca el indice a modificar del array de las habitaciones validas, poco debe fallar esto
    const index = state.validHabCupo.findIndex(
      valid => valid.tomado && valid.codigo == codValid
    );
    if (index == -1) {
      return false;
    }
    // Se desmarca como seleccionado la habitacion a borrar del carrito
    commit("checkValidHab", { index: index, valor: false });
    // Se borra del carrito
    commit("borrar", borrar);
    // SE contesta al componente para mostrar el mensaje de ok
    return true;
  },
  buscarHabitacion({ commit, state, dispatch }, item) {
    let hotelHab = { hotel: null, hab: null };
    state.hoteles.find((h, inx) => {
      hotelHab = { hotel: null, hab: null };
      const indice = h.habitaciones.findIndex(
        hab => hab.habitacion.comparador == item
      );
      if (indice === -1) {
        return false;
      }
      hotelHab.hotel = inx;
      hotelHab.hab = indice;
      return true;
    });
    return hotelHab;
  },
  async agregarPase2Habitacion({ commit, state, dispatch }, item) {
    if (item.comparador != undefined) {
      let hotelHab = await dispatch("buscarHabitacion", item.comparador);
      commit("setPase2Habitacion", { pase: item, localizado: hotelHab });
      return true;
    }
    return false;
  },
  async agregarComida2Habitacion({ commit, state, dispatch }, item) {
    if (item.comparador != undefined) {
      let hotelHab = await dispatch("buscarHabitacion", item.comparador);
      commit("setComida2Habitacion", {
        comida: item.comida,
        localizado: hotelHab
      });
      return true;
    }
    return false;
  },
  async borrarPase2Habitacion({ commit, state, dispatch }, item) {
    let hotelHab = await dispatch("buscarHabitacion", item);
    if (hotelHab.hotel === null || hotelHab.hab === null) {
      return false;
    }
    commit("eliminarPase2Habitacion", hotelHab);
    return true;
  },
  async borrarComida2Habitacion({ commit, state, dispatch }, item) {
    let hotelHab = await dispatch("buscarHabitacion", item);
    if (hotelHab.hotel === null || hotelHab.hab === null) {
      return false;
    }
    commit("eliminarComida2Habitacion", hotelHab);
    return true;
  },
  agregarTraslado({ commit, state, dispatch }, item) {
    const indice = state.traslados.findIndex(
      t => t.unico_hotel === item.unico_hotel
    );
    commit("agregarTraslado", { item: item, indice: indice });
  },
  borrarTraslado({ commit, state, dispatch }, item) {
    const indiceHtl = state.traslados.findIndex(
      t => t.unico_hotel === item.unico
    );
    if (indiceHtl == -1) {
      return false;
    }
    const indiceTraslado = state.traslados[indiceHtl].traslados.findIndex(
      t => t.idTarifa === item.idTarifa
    );
    const aborrar = { indiceTraslado: indiceTraslado, indiceHtl: indiceHtl };
    commit("doBorrarTraslado", aborrar);
    return true;
  },
  saveBoton({ commit, state, dispatch }, item) {
    commit("setBoton", item);
  },
  agregarPase({ commit, state, dispatch }, item) {
    let mapper = new MapperCarrito();
    item["unico_carrito"] = mapper.getUnico();
    commit("guardarPase", item);
  },
  borrarPase({ commit, state, dispatch }, item) {
    commit("doBorrarPase", item);
  },
  prepararcarritoFromDb({ commit }, item) {
    commit("guarCarritoFromDb", item);
  }
};

const mutations = {
  addtoCarrito(state, { item }) {
    if (item.tipo == "c") {
      state.cupos.push(item.data);
    }
    if (item.tipo == "h") {
      var index = state.hoteles.findIndex(
        hotel => hotel.unico_carrito === item.data.unico_carrito
      );

      index == -1
        ? state.hoteles.push(item.data)
        : state.hoteles[index].habitaciones.push(item.data.habitaciones[0]);
    }
  },
  limpiarCarrito(state, { item }) {
    if (item == undefined) {
      state.cupos = [];
      state.hoteles = [];
      state.traslados = [];
      state.tickets = [];
      return;
    }
    if (item.tipo === "c") {
      state.cupos = [];
    }
    if (item.tipo === "h") {
      state.hoteles = [];
    }
  },
  setGastoReserva(state, { item }) {
    state.gastoReserva = item.valor;
  },
  agregarValidHab(state, item) {
    state.validHabCupo.push(item);
  },
  checkValidHab(state, item) {
    state.validHabCupo[item.index].tomado = item.valor;
  },
  limpiarValidHab(state) {
    state.validHabCupo = [];
  },
  setTarifas(state, item) {
    state.tarifas = item;
  },
  borrar(state, item) {
    state.hoteles[item.indexhotel].habitaciones.splice(item.indexhabi, 1);
    if (state.hoteles[item.indexhotel].habitaciones.length == 0) {
      state.hoteles.splice(item.indexhotel, 1);
    }
  },
  setValidarSegunBusqueda(state, item) {
    state.validarSegunBusqueda = item;
  },
  setPase2Habitacion(state, item) {
    state.hoteles[item.localizado.hotel].habitaciones[
      item.localizado.hab
    ].habitacion.tickets = [item.pase.pase];
  },
  setComida2Habitacion(state, item) {
    state.hoteles[item.localizado.hotel].habitaciones[
      item.localizado.hab
    ].habitacion.comidas = [item.comida];
  },
  agregarPase(state, item) {
    state.tickets.push(item);
  },
  eliminarPase2Habitacion(state, item) {
    state.hoteles[item.hotel].habitaciones[item.hab].habitacion.tickets = [];
  },
  eliminarComida2Habitacion(state, item) {
    state.hoteles[item.hotel].habitaciones[item.hab].habitacion.comidas = [];
  },
  agregarTraslado(state, item) {
    if (item.indice === -1) {
      state.traslados.push(item.item);
      return;
    }
    state.traslados[item.indice].traslados.push(item.item.traslados[0]);
  },
  doBorrarTraslado(state, item) {
    delete state.traslados[item.indiceHtl].traslados.splice(
      item.indiceTraslado,
      1
    );
  },
  setBoton(state, item) {
    state.boton = item;
  },
  guardarPase(state, item) {
    state.tickets.push(item);
  },
  doBorrarPase(state, item) {
    state.tickets = state.tickets.filter(t => {
      return t.unico_carrito != item;
    });
  },
  guarCarritoFromDb(state, item) {
    state.cupos = item.cupos;
    state.hoteles = item.hoteles;
    state.tickets = item.tickets;
    state.traslados = item.traslados;
  },
  borrarAdicionales(state) {
    state.tickets = [];
    state.traslados = [];
    state.hoteles.forEach(ht => {
      ht.habitaciones.forEach(hab => {
        hab.habitacion.tickets = [];
        hab.habitacion.comidas = [];
      });
    });
  },
  setOpen(state, item) {
    state.open = item;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
